import AllasPlusLogo from '@/allas/public/image/allas-plus-logo.svg';
import { StandaloneComponent } from '@/types/component';
import { StandaloneArticleTeaserBodytext, StandaloneArticleTeaserBodytextProps } from 'base/components/ArticleTeaser/Bodytext';

export const AllasStandaloneArticleTeaserBodytext: StandaloneComponent<StandaloneArticleTeaserBodytextProps> = (
  props,
) => {
  return <StandaloneArticleTeaserBodytext subscriptionLogo={<AllasPlusLogo />} {...props} />
}
